import { render, staticRenderFns } from "./system_note.vue?vue&type=template&id=962b3fd8"
import script from "./system_note.vue?vue&type=script&lang=js"
export * from "./system_note.vue?vue&type=script&lang=js"
import style0 from "./system_note.vue?vue&type=style&index=0&id=962b3fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports